module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user_feedback_detail clearfix p_background"
  }, [_c('h3', {
    staticClass: "all_title clearfix"
  }, [_c('span', [_vm._v("用户反馈")]), _vm._v(" "), _c('router-link', {
    staticClass: "pull-right cursor color_9 th3",
    attrs: {
      "to": "/feedback_list"
    }
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('section', {
    staticClass: "all_container container_box"
  }, [_c('div', {
    staticClass: "detail"
  }, [_c('section', {
    staticClass: "title th2 color_6"
  }, [_vm._v("反馈内容")]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "top clearfix color_9 clearfix"
  }, [_c('span', {
    staticClass: "item"
  }, [_vm._v("\n\t\t\t\t\t\t反馈人：" + _vm._s(_vm.feedback.schoolcloudUserUsername) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "item text-center"
  }, [_vm._v("\n\t\t\t\t\t\t反馈类型：\n\t\t\t\t\t\t"), (_vm.feedback.feedbackType == '1') ? _c('span', [_vm._v("平台反馈")]) : _vm._e(), _vm._v(" "), (_vm.feedback.feedbackType == '2') ? _c('span', [_vm._v("意见建议")]) : _vm._e(), _vm._v(" "), (_vm.feedback.feedbackType == '3') ? _c('span', [_vm._v("应用反馈"), (_vm.feedback.appName != null) ? _c('span', [_vm._v("-" + _vm._s(_vm.feedback.appName))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "item text-right"
  }, [_vm._v("\n\t\t\t\t\t\t反馈时间：" + _vm._s(_vm._f("datetime")(_vm.feedback.feedbackTime)) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('section', {
    staticClass: "text_show color_9"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.feedback.feedbackComment) + "\n\t\t\t\t\t")]), _vm._v(" "), (_vm.feedbackFiles != null) ? _c('section', {
    staticClass: "imgFile color_308de2"
  }, [_c('img', {
    attrs: {
      "src": _vm.feedbackFiles.filePath,
      "alt": "反馈图片"
    }
  })]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "detail"
  }, [_c('section', {
    staticClass: "title th2 color_6"
  }, [_vm._v("反馈回复")]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "top clearfix color_9"
  }, [_c('span', {
    staticClass: "left pull-left"
  }, [_vm._v("\n\t\t\t\t\t\t变更反馈类型：" + _vm._s(_vm.feedback.remark) + "\n\t\t\t\t\t")]), _vm._v(" "), _c('span', {
    staticClass: "right pull-right"
  }, [_vm._v("\n\t\t\t\t\t\t回复时间：" + _vm._s(_vm._f("datetime")(_vm.feedback.answerTime)) + "\n\t\t\t\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('section', {
    staticClass: "text_show color_9"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.feedback.answerComment) + "\n\t\t\t\t\t")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-4bbb6370"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/user_feedback/detail.vue
// module id = 1254
// module chunks = 1